import { render, staticRenderFns } from "./WeightAndQualityCertificates.vue?vue&type=template&id=348909dc"
import script from "./WeightAndQualityCertificates.vue?vue&type=script&lang=js"
export * from "./WeightAndQualityCertificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports